import { useContext, useCallback } from 'react';
import get from 'lodash/get';
import { FarmContext } from './FarmContext';
import { AppContext } from './AppContext';
import { saveAttachment, deleteAttachment } from './db';
import Table from './Table';

export default function Attachments({ model }) {
    const { user } = useContext(AppContext);
    const { compId, fkdId, formData, setFormData } = useContext(FarmContext);

    let attachmentsModel = 'attachments';
    if (fkdId) attachmentsModel = 'knowledgeattachments';
    let modelId = compId;
    if (fkdId) modelId = fkdId;

    const onChange = evt => {
        const input = evt.target;
        if (input.files && input.files[0]) {

            const fd = new FormData();
            fd.append('file', input.files[0]);
            fd.append(model, modelId);
            saveAttachment(user, attachmentsModel, fd)
                .then(resp => {
                    setFormData(d => ({...d, attachment_set: [...d.attachment_set, resp]}));
                })
        }
    }

    const deleteButton = useCallback((id) => {
        const del = window.confirm('Are you sure you want to delete this attachement?')
        if (del) {
          deleteAttachment(user, attachmentsModel, id);
          setFormData(d => ({...d, attachment_set: d.attachment_set.filter(f => f.id !== id)}));
        }
    }, [user, attachmentsModel, setFormData])


    if (modelId === 'new') return `Please save this ${model} to upload attachments.`
    
    const headers = ['File', ''];
    const rows = get(formData, 'attachment_set', []).map(f => {
        return {
            File: <a href={f.file} rel="noreferrer" target="_blank"> {f.name} </a>,
            id: f.id,
            '': <button
                  className="shadow bg-red-500 hover:bg-red-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                  type="button"
                  onClick={() => deleteButton(f.id)}
                >
                  Delete
                </button>
        }
    });

    return <div>
        {(rows.length > 0) && <h4 className="text-lg text-bold"> Existing attachments </h4>}
        {(rows.length > 0) && <Table headers={headers} rows={rows} />}
        <h4 className="text-lg text-bold"> Add attachement </h4>
        <input type='file' onChange={onChange}/>
    </div>
}